import { render, staticRenderFns } from "./BaseBForm.vue?vue&type=template&id=e032dd4c&scoped=true"
import script from "./BaseBForm.vue?vue&type=script&lang=js"
export * from "./BaseBForm.vue?vue&type=script&lang=js"
import style0 from "./BaseBForm.vue?vue&type=style&index=0&id=e032dd4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e032dd4c",
  null
  
)

export default component.exports